import React from 'react';
import { TextInput } from 'react-native';
import OPComponent from '../op_component';

import { __WEB__ } from '../../../constants/styles';

export default class TextInputPlain extends OPComponent {
  constructor(props) {
    super(props);

    this.autocompleted = false;
    this._inputRef = React.createRef();
  }

  focus = () => {
    // console.log(`focus ${this.props.label}`, event)
    this._inputRef?.current?.focus();
  };

  _handleBlur = (event) => {
    // console.log(`blur ${this.props.label}`, event)
    // check if the value just changed with out any keystrokes, i.e. it was autocompleted and we shouldn't actually blur. keep the focus
    if (this.autocompleted) {
      this._inputRef?.current?.focus();
    }

    if (this.props.onBlur) this.props.onBlur();
  };

  _onChangeText = (value) => {
    const valueLength = this.props.value?.length || 0;
    // check if the value of the input changed by more than one character to determine if it was autocomplete. this is also going to be true if they copy/paste into the form but all they have to do is double tab and it will progress, which is better experience than the alternative.
    this.autocompleted = Math.abs(value.length - valueLength) !== 1;

    if (this.autocompleted) {
      // set autocompleted false if were not stuck in an autocomplete wonky loop
      setTimeout(() => {
        this.autocompleted = false;
      }, 100);
    }

    if (this.props.onChangeText) this.props.onChangeText(value);
  };

  render() {
    const props = this.props;
    const editable = props.editable !== false;

    return (
      <TextInput
        ref={this._inputRef}
        style={props.style}
        autoFocus={props.autoFocus}
        onFocus={props.onFocus}
        onBlur={__WEB__ ? this._handleBlur : props.onBlur}
        onChangeText={__WEB__ ? this._onChangeText : props.onChangeText}
        value={props.value}
        defaultValue={props.defaultValue}
        selectTextOnFocus={props.selectTextOnFocus}
        editable={!!editable}
        readOnly={!editable}
        maxLength={props.maxLength}
        multiline={props.multiline}
        numberOfLines={props.numberOfLines}
        placeholder={props.placeholder}
        placeholderTextColor={props.placeholderTextColor}
        autoCorrect={props.autoCorrect}
        autoComplete={props.autoComplete}
        autoCapitalize={props.autoCapitalize}
        keyboardType={props.keyboardType}
        returnKeyType={props.returnKeyType}
        clearButtonMode={props.clearButtonMode}
        underlineColorAndroid={props.underlineColorAndroid}
        onSubmitEditing={props.onSubmitEditing}
        secureTextEntry={props.secureTextEntry}
        testID={props.testID}
      />
    );
  }
}
